import styled from 'styled-components';

const base = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: ${(props) => props.theme.padding.default};
`;

const Frame = {
  Base: base,
};

export default Frame;
